import React from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import PropTypes from 'prop-types';

import injectT from '../../../../../app/i18n/injectT';
import { RESERVATION_STATE } from '../../../../constants/ReservationState';
import { getApprovedState } from '../../utils';

const UntranslatedManageReservationsDropdown = ({
  t, onInfoClick, reservation,
  onEditClick,
  onEditReservation,
  userCanModify,
  userCanCancel,
}) => {
  const isRequestedReservation = reservation.state === RESERVATION_STATE.REQUESTED;
  const reservationApprovedState = getApprovedState(reservation);

  return (
    <div className="app-ManageReservationDropdown">
      {userCanModify && (
        <DropdownButton
          id="app-ManageReservationDropdown"
          title={t('ManageReservationsList.actionsHeader')}
        >
          <MenuItem onClick={onInfoClick}>
            {t('ManageReservationsList.actionLabel.information')}
          </MenuItem>

          {/*
            TODO: This should be changed so that clicking 'Approve'/'Deny' would utilize
            app.actions.reservationAction.confirmPreliminaryReservation and
            app.actions.reservationAction.denyPreliminaryReservation, respectively,
            instead of having duplicate code for handling approvals/denials in onEditReservation.
          */}
          {isRequestedReservation && (
            <>
              <MenuItem
                onClick={() => onEditReservation(reservation, reservationApprovedState)}
              >
                {t('ManageReservationsList.actionLabel.approve')}
              </MenuItem>
              <MenuItem
                onClick={() => onEditReservation(reservation, RESERVATION_STATE.DENIED)}
              >
                {t('ManageReservationsList.actionLabel.deny')}
              </MenuItem>
            </>
          )}

          <MenuItem
            onClick={onEditClick}
          >
            {t('ManageReservationsList.actionLabel.edit')}
          </MenuItem>

          {userCanCancel && (
            <MenuItem
              onClick={() => onEditReservation(reservation, RESERVATION_STATE.CANCELLED, true)}
            >
              {t('ManageReservationsList.actionLabel.cancel')}
            </MenuItem>
          )}
        </DropdownButton>
      )}
    </div>
  );
};

UntranslatedManageReservationsDropdown.propTypes = {
  t: PropTypes.func,
  onInfoClick: PropTypes.func,
  reservation: PropTypes.object,
  onEditClick: PropTypes.func,
  onEditReservation: PropTypes.func,
  userCanCancel: PropTypes.bool,
  userCanModify: PropTypes.bool,
};
export { UntranslatedManageReservationsDropdown };

export default injectT(UntranslatedManageReservationsDropdown);
